import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';
import { ApiCallError, callFunction } from '@/lib/api';
import { GgopViewer } from './GgopViewer';
import type { GgopView } from './ReceivedGgopPanel';

/** "Vis / udskriv" on a GGOP outbox row (GGOP-S 3.5.12): the sent plan with MedCom's stylesheet. */
export function GgopOutboxView({ clinicId, exchangeId, patientName, canRevealCpr }: { clinicId: string; exchangeId: string; patientName: string; canRevealCpr: boolean }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [view, setView] = useState<GgopView | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function toggle() {
    if (open) {
      setOpen(false);
      return;
    }
    setOpen(true);
    if (view) return;
    setError(null);
    try {
      setView(await callFunction<Record<string, string>, GgopView>('communicate-ggop', { action: 'view', clinic_id: clinicId, exchange_id: exchangeId }));
    } catch (err) {
      setError(err instanceof ApiCallError ? err.message : t('patients.ggop.view_failed', 'Genoptræningsplanen kunne ikke vises.'));
    }
  }

  return (
    <div className="mt-3 space-y-2">
      <Button type="button" size="sm" variant="secondary" onClick={() => void toggle()}>
        {open ? t('patients.ggop.hide_plan', 'Skjul plan') : t('patients.ggop.show_plan', 'Vis / udskriv plan')}
      </Button>
      {open && error && <p role="alert" className="text-sm text-ds-red-ink">{error}</p>}
      {open && !view && !error && <p className="text-sm text-ds-muted">{t('patients.ggop.loading', 'Henter genoptræningsplanen…')}</p>}
      {open && view && <GgopViewer xml={view.xml} planType={view.planType} patientId={view.patientId} patientName={view.patientName ?? patientName} canRevealCpr={canRevealCpr} />}
    </div>
  );
}
